var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"current-analysis"},[(this.next == 0)?_c('GatherInfo',{on:{"data":_vm.handleData}}):_vm._e(),(this.next == 1)?_c('SimpleOutcome',{attrs:{"showGraph":_vm.showGraph,"data":this.data}}):_vm._e(),(this.next == 2)?_c('Outcome',{attrs:{"back":_vm.back,"role-analysis":this.roleAnalysis,"data":this.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }